var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfFile = function SvgPdfFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#30A8FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.83333
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.083 20.081c0.221 0 0.4329-0.0878 0.5892-0.244 0.1563-0.1563 0.2441-0.3683 0.2441-0.5893v-13.356c-4e-4 -1.3203-0.5252-2.5863-1.4589-3.5197-0.9338-0.93342-2.2-1.4578-3.5203-1.4578h-10.021c-0.22102 0-0.43298 0.087797-0.58926 0.24408s-0.24408 0.36824-0.24408 0.58926v17.5c0 0.221 0.0878 0.433 0.24408 0.5893 0.15628 0.1562 0.36824 0.244 0.58926 0.244h14.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.75 0.98438v3.2675c0 0.22101 0.0878 0.43297 0.2441 0.58925s0.3682 0.24408 0.5892 0.24408h3.2667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.0658 13c0 0.3315-0.1317 0.6495-0.36612 0.8839s-0.55236 0.3661-0.88388 0.3661h-1.25v-2.5h1.25c0.33152 0 0.64946 0.1317 0.88388 0.3661s0.36612 0.5524 0.36612 0.8839z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5658 16.75v-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.7325 11.75c0.66305 0 1.299 0.2634 1.7678 0.7322 0.4689 0.4689 0.7322 1.1048 0.7322 1.7678s-0.2633 1.2989-0.7322 1.7678c-0.4688 0.4688-1.1047 0.7322-1.7678 0.7322v-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.899 16.75v-4.1667c0-0.221 0.0878-0.4329 0.244-0.5892 0.1563-0.1563 0.3683-0.2441 0.5893-0.2441h1.6667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.899 14.25h1.6666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(0 .5)",
    width: 20,
    height: 20,
    fill: "#fff"
  })))));
};
export default SvgPdfFile;